import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminMedicationNeedsMoreInfo, adminMedicationSubmit } from '@api/adminSupplements';
import {
  IAdminMedicationNeedsMoreInfoPayload,
  IAdminMedicationSubmitPayload,
} from '@interfaces/adminMedications';

export const handleAdminMedicationNeedsMoreInfo = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminMedicationNeedsMoreInfoPayload
>('adminMedicationNeedsMoreInfo', adminMedicationNeedsMoreInfo);

export const handleAdminMedicationConfirm = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminMedicationSubmitPayload
>('adminMedicationSubmit', adminMedicationSubmit);
